import { Capacitor, registerPlugin } from '@capacitor/core';

const NativeTracking = registerPlugin('NativeTracking');

export async function updateNativeTrackingAuth(xAuth) {
  if (!isNativeTrackingAvailable()) return;
  return NativeTracking.updateAuth({ xAuth });
}

export function isNativeTrackingAvailable() {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

export async function startNativeTracking({ url, xAuth, intervalSeconds = 15, minDistanceMeters = 15, heartbeatSeconds = 60 }) {
  if (!isNativeTrackingAvailable()) {
    return { running: false };
  }

  return NativeTracking.start({
    url,
    xAuth,
    intervalSeconds,
    minDistanceMeters,
    heartbeatSeconds
  });
}

export async function checkNativeTrackingPermissions() {
  if (!isNativeTrackingAvailable()) {
    return { location: true, approximateLocation: false, notifications: true, locationServices: true };
  }

  return NativeTracking.checkTrackingPermissions();
}

export async function stopNativeTracking() {
  if (!isNativeTrackingAvailable()) {
    return { running: false };
  }

  return NativeTracking.stop();
}

export async function getNativeTrackingStatus() {
  if (!isNativeTrackingAvailable()) {
    return { running: false };
  }

  return NativeTracking.status();
}

export async function requestNativeTrackingPermissions() {
  if (!isNativeTrackingAvailable()) {
    return { location: true, notifications: true };
  }

  return NativeTracking.requestTrackingPermissions();
}

export function addNativeTrackingStatusListener(callback) {
  if (!isNativeTrackingAvailable()) {
    return Promise.resolve({ remove() {} });
  }

  return NativeTracking.addListener('trackingStatus', callback);
}

export function openNativeTrackingSettings(target = 'app') {
  if (!isNativeTrackingAvailable()) {
    return Promise.resolve();
  }

  return NativeTracking.openSettings({ target });
}
